module.exports = __webpack_public_path__ + "img/ssyx_20.8bf954e0.jpg";